<template>
  <vue-scroll>
    <div class="page-contacts flex column scrollable only-y mb-20" id="page-contacts"
      v-show="userPermissionsFilter.admin" v-loading="pageLoading" :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <resize-observer @notify="__resizeHanlder" />
      <div class="contacts-root box grow flex gaps justify-center" :class="contactsClass">
        <div class="card-base card-shadow--small search-card scrollable only-y">
          <h1 class="mt-0 pageTitle">MTS System Users</h1>

          <el-input prefix-icon="el-icon-search" placeholder="Search a user" clearable v-model="search">
          </el-input>

          <div class="o-050 text-right mt-10 mb-30">
            <strong>{{ usersFiltered.length }}</strong> MTS System Users
          </div>


          <el-select v-model="selectedCompanyId" placeholder="Select company" filterable clearable class="mb-10"
            style="width: 100%" @change="companyChanged">
            <el-option v-for="company in companyNames" :key="company.id" :label="company.name" :value="company.id">
            </el-option>
          </el-select>

          <el-button v-show="userPermissionsFilter.addusers" icon="mdi mdi-account-plus" type="primary"
            @click="openDialog({})">
            add MTS user</el-button>
        </div>
        <div class="contacts-list box grow scrollable only-y">
          <div v-for="c in usersFiltered" :key="c.id" class="flex contact" @click="openDialog(c)">
            <div class="star align-vertical p-10 fs-22">
              <i class="mdi mdi-checkbox-marked-circle align-vertical-middle" v-if="c.active"></i>
              <i class="
                  mdi mdi-checkbox-blank-circle-outline
                  align-vertical-middle" v-if="!c.active"></i>
            </div>
            <div class="avatar align-vertical">
              <img :src="imagePlaceholder" class="align-vertical-middle" alt="user avatar" />
            </div>
            <div class="info box grow flex">
              <div class="name box grow flex column justify-center p-10">
                <div class="fullname fs-18">
                  <strong>{{ c.firstName }} {{ c.lastName }}</strong>
                </div>

                <div class="phone fs-14 secondary-text">
                  {{ c.phoneNumber }}
                </div>
                <div class="email fs-14 secondary-text accent-text">
                  {{ c.email }}
                </div>
              </div>
              <div class="phone align-vertical p-10">
                <span class="align-vertical-middle">{{ c.phoneNumber }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <user-dialog :dialogFormVisible.sync="dialogFormVisible" :userdata="userdata" :companyNames="companyNames"
			v-on:saveCurrentUser="saveCurrentUser($event)" v-on:activateUser="activateCurrentUser($event)"></user-dialog> -->

      <el-dialog :show-close="true" :custom-class="'user-dialog'" :visible="dialogFormVisible" @close="closeDialog"
        :before-close="handleClose">
        <div class="avatar-box">
          <img :src="imagePlaceholder" alt="user avatar" />
          <div class="star" @click="checkActive">
            <i class="mdi mdi-checkbox-marked-circle align-vertical-middle" v-if="userdata.active"></i>
            <i class="
                mdi mdi-checkbox-blank-circle-outline
                align-vertical-middle
              " v-if="!userdata.active"></i>
          </div>
        </div>
        <div class="form-box">
          <div class="row">
            <!--<div class="row">
              <div class="col col-md-12 d-flex">
                <strong>Customer ID:</strong>
                <el-input
                  placeholder="Customer ID"
                  v-model="userdata.customerNumber"
                  name="customerNumber"
                  v-validate="'required'"
                  data-vv-as="Customer ID"
                  :readonly="readOnlyMode"
                  @change="propertyChanged"
                ></el-input>
                <transition name="fade">
                  <span class="danger-text">{{
                    errors.first("customerNumber")
                  }}</span>
                </transition>
              </div>
            </div>-->

            <div class="row mt-12">
              <div class="col col-md-12">
                <strong>Company Name:</strong>
                <el-select v-model="userdata.companyID" placeholder="Select company" filterable clearable class="mb-10"
                  style="width: 100%" @change="companyChanged">
                  <el-option v-for="company in companyNames" :key="company.id" :label="company.name"
                    :value="company.id">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="row">
              <div class="col col-md-12 d-flex">
                <strong>First Name:</strong>
                <el-input placeholder="Firstname" v-model="userdata.firstName" name="firstname" v-validate="'required'"
                  data-vv-as="first name" :readonly="readOnlyMode" @change="propertyChanged"></el-input>
                <transition name="fade">
                  <span class="danger-text">{{
                    errors.first("firstname")
                  }}</span>
                </transition>
              </div>
            </div>

            <div class="row mt-12">
              <div class="col col-md-12 d-flex">
                <strong>Last Name:</strong>
                <el-input placeholder="Lastname" v-model="userdata.lastName" :readonly="readOnlyMode"
                  @change="propertyChanged" name="lastname" v-validate="'required'" data-vv-as="last name"></el-input>
                <transition name="fade">
                  <span class="danger-text">{{
                    errors.first("lastname")
                  }}</span>
                </transition>
              </div>
            </div>

            <div class="row mt-12">
              <div class="col col-md-12 d-flex">
                <strong>Email:</strong>
                <el-input placeholder="Email" v-model="userdata.email" :readonly="readOnlyMode"
                  @change="propertyChanged" name="email" v-validate="'required|email'" data-vv-as="email"></el-input>
                <transition name="fade">
                  <span class="danger-text">{{ errors.first("email") }}</span>
                </transition>
              </div>
            </div>

            <div class="row mt-12">
              <div class="col col-md-12 d-flex">
                <strong>Phone Number:</strong>
                <VuePhoneNumberInput v-model="userformattedNumber" color="dodgerblue" style="line-height:1"
                  :default-country-code="countrycode" clearable class="mb-2" @update="onUpdateUserMobileNumber" />
                <transition name="fade">
                  <span class="danger-text">{{ errors.first("phone") }}</span>
                </transition>
              </div>
            </div>
            <div class="row mt-12">
              <div class="col col-md-12">
                <strong>Operating Country:</strong>
                <el-select v-model="userdata.OperatingCountryID" filterable clearable placeholder="Operating Country"
                  autocomplete="off" autofill="off" class="mb-10" style="width:100%" name="OperatingCountryID"
                  v-validate="'required'" data-vv-as="Operating Country" disabled>
                  <el-option v-for="country in countries" :key="country.id" :label="country.name"
                    :value="country.id"></el-option>
                </el-select>
              </div>
            </div>

            <div class="row mt-12" v-show="userPermissionsFilter.addusers">
              <div class="col col-md-12">
                <el-button type="primary" class="btn-group" style="width: 100%" @click="saveCurrentUser">
                  <i class="mdi mdi-content-save"> </i><span> Save</span>
                </el-button>
              </div>
              <div class="col col-md-12 mt-10">
                <el-button type="primary" class="btn-group" style="width: 100%" @click="resendEmail">
                  <i class="mdi mdi-send-secure"> </i><span> Resend Email</span>
                </el-button>
              </div>
            </div>

            <div class="row mt-12" v-show="userdata.id != null && userPermissionsFilter.editusers">
              <div class="col col-md-12">
                <el-button type="danger" class="btn-group" style="width: 100%" @click="deactivateUser"
                  v-if="userdata.active">
                  <i class="mdi mdi-cancel"></i><span> Deactivate</span>
                </el-button>
                <el-button type="success" class="btn-group" style="width: 100%" @click="activateCurrentUser" v-else>
                  <i class="mdi mdi-cancel"></i><span> Activate</span>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </vue-scroll>
</template>

<script>
import PermissionsMixin from "@/mixins/PermissionsMixins";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  name: "Users",
  components: {
    VuePhoneNumberInput
  },
  data() {
    return {
      search: "",
      userformattedNumber: "",
      countrycode: "",
      pageWidth: 0,
      userdata: {
        createdBy: self.sub,
        id: "",
        email: "",
        phoneNumber: "",
        twoFactorEnabled: false,
        firstName: "",
        middleName: "",
        lastName: "",
        dOB: "",
        active: 1,
        companyID: 0,
        isOrganization: "false",
        organizationName: "",
        gender: "",
        platform: "",
        operatingCountryID: 212
      },
      selectedCompanyId: "",
      imagePlaceholder:
        "data:image/jpeg;base64,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"
    };
  },
  computed: {
    usersFiltered() {
      return this.users.filter(
        ({ firstName, lastName, email, phoneNumber, IsOrganization }) =>
          (firstName + lastName + email + phoneNumber + IsOrganization)
            .toString()
            .toLowerCase()
            .indexOf(this.search.toString().toLowerCase()) !== -1
      );
    },
    contactsClass() {
      return this.pageWidth >= 870
        ? "large"
        : this.pageWidth >= 760
          ? "medium"
          : "small";
    },
    readOnlyMode() {
      return (
        !this.userPermissionsFilter.addusers &&
        !this.userPermissionsFilter.editusers
      );
    },
  },
  methods: {
    openDialog(data) {
      this.userdata = data;
      this.dialogFormVisible = true;
    },
    setPageWidth() {
      this.pageWidth = document.getElementById("page-contacts").offsetWidth;
    },
    __resizeHanlder: _.throttle(function (e) {
      this.setPageWidth();
    }, 700),
    activateCurrentUser() {
      this.dialogFormVisible = false;
      this.lockout = true;
      this.activateUser(this.userdata.id, true)
        .then((result) => {
          if (result) {
            this.successMessage("User has been activated.");
            this.getUsers();
          }
        })
        .catch((err) => this.errorMessage("An error occured."));
    },
    deactivateUser() {
      this.dialogFormVisible = false;
      this.lockout = false;
      this.activateUser(this.userdata.id, false)
        .then((result) => {
          if (result) {
            this.successMessage("User has been deactivated.");
            this.getUsers();
          }
        })
        .catch((err) => this.errorMessage("An error occured."));
    },
    companyChanged(e) {
      this.fetchUsers(e);
      if (e) {
        this.companyNames.forEach(cntry => {
          if (cntry.id === e) {
            this.userdata.OperatingCountryID = cntry.countryID;
            const codesn = this.countries.map((err) => {
              if (err.id == cntry.countryID) {
                this.countrycode = err.code;
                return err.code;
              }
              else {

              }
            });
          }
        });
      }
    },
    onUpdateUserMobileNumber(payload) {
      this.userdata.phoneNumber = payload.formattedNumber;
    },
    fetchUsers(selectedCompanyId) {
      this.getUsers(selectedCompanyId);
    },
    saveCurrentUser() {
      let self = this;
      if (
        !this.$validator.errors.has("firstname") &&
        !this.$validator.errors.has("lastname") &&
        !this.$validator.errors.has("email") &&
        !this.$validator.errors.has("phone")
      ) {
        this.$validator.reset();
        if (this.userdata.id && this.userdata.id.length > 0) {
          this.startLoader("Updating BO User...");
          this.updateBOUser(this.userdata)
            .then((result) => {
              if (result.id && result.id.length > 0) {
                this.fetchUsers();
                this.stopLoader();
                this.successMessage("User updated successfully.");
              }
              else {
                this.fetchUsers();
                this.stopLoader();
                this.errorMessage(result.message.description);
              }
            })
            .catch((err) => {
              this.stopLoader();
              console.log(err);
              this.errorMessage("Failed to update user.");
            });
        }
        else {
          this.startLoader("Creating BO User...");
          this.saveUser(this.userdata)
            .then((result) => {
              if (result.id && result.id.length > 0) {
                this.fetchUsers();
                this.stopLoader();
                this.successMessage("User created successfully.");
              }
              else {
                this.fetchUsers();
                this.stopLoader();
                this.errorMessage(result.message.description);
              }
            })
            .catch((err) => {
              this.stopLoader();
              console.log(err);
              this.errorMessage("Failed to create user.");
            });
        }
      }
      this.dialogFormVisible = false;
    },
    checkActive() {
      if (!this.readOnlyMode) {
        this.userdata.active = !this.userdata.active;
      }
    },
    resendEmail() {
      this.reSendConfirmationEmail(this.userdata.id)
        .then((result) => {
          if (result) {
            this.successMessage("Email sent.");
          } else {
            this.errorMessage("Email not sent");
          }
        })
        .catch(() => this.errorMessage("An error occured"));
    },
    lockUserAccount(lock) {
      var state = lock ? "lock" : "unlock";
      this.reSendConfirmationEmail(this.userdata.id, lock)
        .then((result) => {
          if (result) {
            this.successMessage(`Account ${state}ed`);
          } else {
            this.errorMessage(`Failed to ${state} account`);
          }
        })
        .catch(() => this.errorMessage("An error occured"));
    },
  },
  mounted() {
    this.getUsers();
    this.setPageWidth();
  },
  created() {
    const that = this;
    that.getLoggedInCompany().then((loggedInCompany) => {
      this.getCompanyNames();
      that.getCountries();
    })
      .catch(err => console.log(err));
  },
  mixins: [PermissionsMixin],
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_variables";
@import "../../assets/scss/_variables";
@import "../../assets/scss/dialogs";

.page-contacts {
  color: #fff;
  height: 100%;
  margin: 0 !important;
  padding: 20px;
  padding-bottom: 10px;
  box-sizing: border-box;

  .search-card {
    padding: 50px;
    max-width: 350px;
    max-height: 370px;
    box-sizing: border-box;
    margin-bottom: 15px;

    .el-input,
    .el-button {
      width: 100%;
    }
  }

  .search-wrap {
    margin: 0 auto;
    margin-bottom: 10px;
    padding: 0px 30px;
    box-sizing: border-box;
    width: 100%;
    max-width: 600px;

    i {
      display: inline-block;
      width: 22px;
    }

    input {
      outline: none;
      background: transparent;
      border: none;
      font-size: 15px;
      position: relative;
      top: -2px;
      width: 100%;
      padding: 0;
      color: $text-color;
    }

    .contacts-tot {
      margin-right: 20px;
      margin-left: 10px;
    }

    a {
      border-bottom: 1px solid;
      text-decoration: none;
      color: $text-color;

      &:hover {
        opacity: 0.6;
      }
    }
  }

  .contacts-root {
    max-height: 100%;
  }

  .contacts-list {
    //margin: 0 auto;
    width: 100%;
    max-width: 965px;
    padding: 0px 30px;
    box-sizing: border-box;

    .contact {
      margin: 10px 0;
      padding: 5px;
      box-sizing: border-box;
      cursor: pointer;
      transition: all 0.5s 0.25s;

      .star {
        .mdi-star {
          color: #ffd730;
        }

        .mdi-star-outline {
          opacity: 0.5;
        }
      }

      .avatar {
        width: 60px;
        transition: all 0.5s 0.25s;

        img {
          border: 1px solid transparentize($text-color, 0.9);
          box-sizing: border-box;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          transition: all 0.5s 0.25s;
        }
      }

      .info {
        word-break: break-word;

        .name {
          //.fullname {}

          .email {
            opacity: 0;
            line-height: 0;
            transition: all 0.5s 0.25s;
          }

          .phone {
            display: none;
          }
        }

        //.phone {}
      }

      &:hover {
        margin: 15px -20px;
        padding: 10px;
        background-color: lighten($background-color, 20%);
        border-radius: 5px;
        box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09),
          0 3px 6px 0 rgba(0, 0, 0, 0.065);

        .avatar {
          width: 90px;

          img {
            width: 90px;
            height: 90px;
          }
        }

        .info {
          .name {
            .email {
              opacity: 1;
              line-height: 1.4;
            }
          }
        }
      }
    }
  }

  .contacts-root {
    &.medium {
      .search-card {
        padding: 20px;
        max-width: 260px;
        max-height: 360px;
      }
    }

    &.small {
      overflow-y: auto;
      display: block;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      padding: 5px;

      .search-card {
        padding: 20px;
        max-width: 100%;
        width: 100%;
        //max-height: 240px;
        flex: none;
        -webkit-box-flex: none;
        -ms-flex: none;
        display: block;
        overflow: hidden !important;
      }

      .contacts-list {
        flex: none;
        -webkit-box-flex: none;
        -ms-flex: none;
        display: block;
        overflow: hidden !important;
      }
    }
  }
}

@media (max-width: 768px) {
  .page-contacts {
    .search-wrap {
      padding: 0;
    }

    .contacts-list {
      padding: 0px;

      .contact {
        .avatar {
          width: 40px;

          img {
            width: 40px;
            height: 40px;
          }
        }

        .info {
          .phone {
            display: none;
          }

          .name {
            .phone {
              display: block;
            }
          }
        }

        &:hover {
          margin: 15px 0px;

          .avatar {
            width: 60px;

            img {
              width: 60px;
              height: 60px;
            }
          }
        }
      }
    }

    .contacts-root {
      &.medium {
        .contacts-list {
          padding: 0 30px;
        }
      }

      &.small {
        .contacts-list {
          padding: 8px;
        }
      }
    }
  }
}
</style>